"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableableProperties = exports.defaultProperties = void 0;
var yup = __importStar(require("yup"));
var defaultProperties = yup.object({
    isHidden: yup
        .boolean()
        .meta({ description: 'sets visibility:hidden to the component style node' })
        .notRequired(),
    isCollapsed: yup
        .boolean()
        .meta({ description: 'sets isCollapsed for component' })
        .notRequired(),
});
exports.defaultProperties = defaultProperties;
var disableableProperties = yup.object({
    isDisabled: yup
        .boolean()
        .meta({ description: 'disables the component' })
        .default(false),
});
exports.disableableProperties = disableableProperties;
//# sourceMappingURL=Core.schema.js.map